import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
        lng: "en",
        fallbackLng: 'en',
        debug: true,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    'Rejected Application': 'Your application has been rejected.',
                    'Thank You Application Msg': 'Thank you for completing your task! Our team will review your application and get back to you shortly.',
                    'Thank You Apply MSG': 'Thanks for applying! Please check your email or text messages to continue our application process.',
                    'Job Description': 'Job Description',
                    'Start Your Application': 'Start Your Application',
                    'First Name': 'First Name',
                    'Last Name': 'Last Name',
                    'Email': 'Email',
                    'Phone Number': 'Phone Number',
                    'SMSContent': 'By checking this box, I authorize <homepage>DSP Logistics LLC</homepage> (dspworkplace) to send automated messages from my employer, including company communications such as my application status or other work-related messages, to my phone number. Message/data rates may apply. Message frequency varies. Text HELP for help or STOP to opt out. <privacy>Privacy Policy</privacy> and <terms>Terms & Conditions</terms>',
                    'CallConsent': 'By checking this box, I agree to receive calls regarding my application or retainment.',
                    'Continue': 'Continue',
                    'Application not found': 'Application not found',
                    'This position is closed': 'This position is closed',
                    'This position is no longer available': 'This position is no longer available',
                    'Enter your first name': 'Enter your first name',
                    'Enter your last name': 'Enter your last name',
                    'Enter a valid email address': 'Enter a valid email address',
                    'A valid email is required': 'A valid email is required',
                    'Enter a valid phone number': 'Enter a valid phone number',
                    'Use of your phone number is required to open an application': 'Use of your phone number is required to open an application.',
                    'Use of your phone number for calls is required to open an application': 'Use of your phone number for calls is required to open an application.',
                    'Please answer the following questions': 'Please answer the following questions.',
                    'You have': 'You have',
                    'questions to answer': 'questions to answer.',
                    'Thank you for your interest in becoming a Delivery Associate! Please answer the following questions and we will get you up and earning quickly': 'Thank you for your interest in becoming a Delivery Associate! Please answer the following questions and we will get you up and earning quickly!',
                    'Get Started': 'Get Started',
                    'Previous': 'Previous',
                    'Submit': 'Submit',
                    'Next': 'Next',
                    'Details': 'Details',
                    'Location': 'Location',
                    'Event Name': 'Event Name',
                    'With': 'With',
                    'This field is required': 'This field is required',
                    'Please select a date': 'Please select a date',
                    'Please select a time': 'Please select a time',
                    'Choose a date': 'Choose a date',
                    'Choose a time': 'Choose a time',
                    'please watch the video': 'please watch the video',
                    'Address Line': 'Address Line',
                    'City': 'City',
                    'State': 'State',
                    'Zip Code': 'Zip Code',
                    'Enter a valid 5 or 9 digit ZIP Code (e.g. 12345 or 12345-6789)': 'Enter a valid 5 or 9 digit ZIP Code (e.g. 12345 or 12345-6789)',
                    'Warning: City is required': 'Warning: City is required',
                    'Warning: State is required': 'Warning: State is required',
                    'Warning: Zip Code is required': 'Warning: Zip Code is required',
                    'Apply now': 'Apply now',
                    'please record a video': 'please record a video',
                    'Retake Video': 'Retake Video',
                    'Great job! You completed your part. The next step is ours! We will contact you shortly. Please reach out if you have any questions.': 'Great job! You completed your part. The next step is ours! We will contact you shortly. Please reach out if you have any questions.',
                    'Front': 'Front',
                    'Back': 'Back'
                }
            },
            es: {
                translation: {
                    'Rejected Application': 'Su solicitud ha sido rechazada.',
                    'Thank You Application Msg': '¡Gracias por completar tu tarea! Nuestro equipo revisará tu solicitud y te contactará en breve.',
                    'Thank You Apply MSG': '¡Gracias por tu solicitud! Revisa tu correo electrónico o mensajes de texto para continuar con el proceso de solicitud.',
                    'Job Description': 'Descripción del trabajo',
                    'Start Your Application': 'Comience su solicitud',
                    'First Name': 'Nombre de pila',
                    'Last Name': 'Apellido',
                    'Email': 'Correo electrónico',
                    'Phone Number': 'Número de teléfono',
                    'SMSContent': 'Al marcar esta casilla, autorizo a <homepage>DSP Logistics LLC</homepage> (dspworkplace) a enviar mensajes automatizados de mi empleador, incluyendo comunicaciones de la empresa como el estado de mi solicitud u otros mensajes relacionados con el trabajo, a mi número de teléfono. Pueden aplicarse tarifas de mensajes/datos. La frecuencia de los mensajes varía. Envía HELP para obtener ayuda o STOP para cancelar la suscripción. <privacy>Política de Privacidad</privacy> y nuestros <terms>Términos y Condiciones</terms>.',
                    'CallConsent': 'Al marcar esta casilla, acepto recibir llamadas con respecto a mi solicitud o retención.',
                    'Continue': 'Continuar',
                    'Application not found': 'Aplicación no encontrada',
                    'This position is closed': 'Esta posición está cerrada',
                    'This position is no longer available': 'Esta posición ya no está disponible',
                    'Enter your first name': 'Ingrese su nombre',
                    'Enter your last name': 'Introduce tu apellido',
                    'Enter a valid email address': 'Introduzca una dirección de correo electrónico válida',
                    'A valid email is required': 'Se requiere un correo electrónico válido',
                    'Enter a valid phone number': 'Introduzca un número de teléfono válido',
                    'Use of your phone number is required to open an application': 'Es necesario utilizar su número de teléfono para abrir una solicitud.',
                    'Use of your phone number for calls is required to open an application': 'Para abrir una aplicación es necesario utilizar su número de teléfono para realizar llamadas.',
                    'Please answer the following questions': 'Por favor responda las siguientes preguntas.',
                    'You have': 'Tienes',
                    'questions to answer': 'preguntas para responder.',
                    'Thank you for your interest in becoming a Delivery Associate! Please answer the following questions and we will get you up and earning quickly': '¡Gracias por su interés en convertirse en Asociado de Reparto! Responda las siguientes preguntas y le ayudaremos a comenzar a generar ingresos rápidamente.',
                    'Get Started': 'Empezar',
                    'Previous': 'Previo',
                    'Submit': 'Entregar',
                    'Next': 'Próximo',
                    'Details': 'Detalles',
                    'Location': 'Ubicación',
                    'Event Name': 'Nombre del evento',
                    'With': 'Con',
                    'This field is required': 'Este campo es obligatorio',
                    'Please select a date': 'Por favor seleccione una fecha',
                    'Please select a time': 'Por favor seleccione una hora',
                    'Choose a date': 'Elige una fecha',
                    'Choose a time': 'Elige una hora',
                    'please watch the video': 'Por favor mira el video',
                    'Address Line': 'Línea de dirección',
                    'City': 'Ciudad',
                    'State': 'Estado',
                    'Zip Code': 'Código postal',
                    'Enter a valid 5 or 9 digit ZIP Code (e.g. 12345 or 12345-6789)': 'Ingrese un código postal válido de 5 o 9 dígitos (por ejemplo, 12345 o 12345-6789)',
                    'Warning: City is required': 'Advertencia: Se requiere ciudad',
                    'Warning: State is required': 'Advertencia: El estado es obligatorio',
                    'Warning: Zip Code is required': 'Advertencia: El código postal es obligatorio',
                    'Apply now': 'Aplicar ahora',
                    'please record a video': 'por favor graba un video',
                    'Retake Video': 'Volver a grabar el video',
                    'Great job! You completed your part. The next step is ours! We will contact you shortly. Please reach out if you have any questions.': '¡Excelente trabajo! Has completado tu parte. ¡El siguiente paso es nuestro! Nos pondremos en contacto contigo en breve. Por favor, no dudes en contactarnos si tienes alguna pregunta.',
                    'Front': 'Frente',
                    'Back': 'Atrás'
                }
            }
        }
    });


export default i18n;